import React, { useEffect, useState } from "react";
import { Phone, PhoneIncoming, UserPlus, ArrowRight, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../software/api";

export const localNumber = (n) => {
  const d = (n || "").replace(/\D/g, "");
  return d.startsWith("61") && d.length === 11 ? `0${d.slice(2)}` : d;
};

// Polls ringing calls so every office screen shows the same Caller ID pop-up.
export function IncomingCalls({ onGoTo, onAddNew }) {
  const [calls, setCalls] = useState([]);
  const [hidden, setHidden] = useState([]);
  useEffect(() => {
    const f = () => { if (document.visibilityState === "visible") api("GET", "/calls/active").then(setCalls).catch(() => {}); };
    f(); const t = setInterval(f, 3000);
    window.addEventListener("aqualux:calls-changed", f);
    return () => { clearInterval(t); window.removeEventListener("aqualux:calls-changed", f); };
  }, []);
  const take = async (c, then) => {
    try {
      const r = await api("POST", `/calls/${c.id}/claim`);
      setCalls((xs) => xs.filter((x) => x.id !== c.id));
      if (!r.claimed) { toast.info(`${r.answered_by || "Someone"} already took this call.`); return; }
      then(c);
    } catch (e) { toast.error(e.message || "Could not open the call."); }
  };
  const shown = calls.filter((c) => !hidden.includes(c.id));
  if (!shown.length) return null;
  return (
    <div className="fixed bottom-6 right-4 z-[80] flex flex-col gap-2 w-[340px] max-w-[calc(100vw-2rem)]" data-testid="incoming-calls">
      {shown.map((c) => <CallCard key={c.id} c={c} onHide={() => setHidden((h) => [...h, c.id])}
        onGo={() => take(c, onGoTo)} onAdd={() => take(c, onAddNew)} />)}
    </div>
  );
}

function CallCard({ c, onHide, onGo, onAdd }) {
  const known = !!c.client_id;
  return (
    <div className="rounded-lg border-2 border-emerald-500 bg-white shadow-2xl overflow-hidden call-pop" data-testid={`incoming-call-${c.id}`}>
      <div className="flex items-center justify-between bg-emerald-600 text-white px-3 py-1.5">
        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider"><PhoneIncoming className="h-4 w-4 animate-pulse" /> Incoming call{c.source === "test" ? " (test)" : ""}</span>
        <button onClick={onHide} data-testid="incoming-call-hide" title="Hide on this computer" className="h-6 w-6 rounded hover:bg-white/20 flex items-center justify-center"><X className="h-4 w-4" /></button>
      </div>
      <div className="p-3">
        <p className="font-display font-bold text-lg text-slate-900 leading-tight" data-testid="incoming-call-name">{known ? `${c.client_name} calling…` : "Unknown Caller…"}</p>
        {known && <p className="text-sm text-slate-600 mt-0.5" data-testid="incoming-call-address">{c.client_address || "No address on file"}</p>}
        <p className="text-xs font-mono2 text-slate-500 mt-1 flex items-center gap-1" data-testid="incoming-call-number"><Phone className="h-3 w-3" /> {localNumber(c.number) || "Number withheld"}</p>
        <div className="mt-3 flex gap-2">
          {known
            ? <button onClick={onGo} data-testid="incoming-call-goto" className="flex-1 inline-flex items-center justify-center gap-2 rounded-md bg-[#123a63] hover:bg-[#1f4e86] text-white text-sm font-bold py-2 transition-colors">Go to client <ArrowRight className="h-4 w-4" /></button>
            : <button onClick={onAdd} data-testid="incoming-call-add-client" className="flex-1 inline-flex items-center justify-center gap-2 rounded-md bg-[#8bc53f] hover:bg-[#7ab232] text-white text-sm font-bold py-2 transition-colors"><UserPlus className="h-4 w-4" /> Add New Client</button>}
          <button onClick={onHide} data-testid="incoming-call-ignore" title="Hide on this computer only — other screens keep ringing" className="px-4 rounded-md border border-slate-300 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-bold uppercase transition-colors">Ignore</button>
        </div>
      </div>
    </div>
  );
}
